import { Account } from "@components/features/account";
import Game from "@components/features/game";
import { GameDetails } from "@components/features/game-details";
import GameEdit from "@components/features/game-edit";
import Home from "@components/features/home";
import Marketplace from "@components/features/marketplace";
import { Profile } from "@components/features/profile";
import { PublicGame } from "@components/features/publicGame";
import Register from "@components/features/register";
import Review from "@components/features/review";
import { Settings } from "@components/features/settings";
import SignIn from "@components/features/signIn";
import { TransactionDetail } from "@components/features/transaction-details";
import { Transactions } from "@components/features/transactions";
import { connect, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import { RootState } from "./store";

const AppRouter = () => {
  const user = useSelector((state: RootState) => state.user.user);

  const hasUser = !!user.uuid;
  const isLoading = !!user.isLoading;

  const isUserInfilled = () => {
    if (user?.firstName && user?.lastName && user?.dob) {
      return true;
    }
    return false;
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            hasUser ? (
              isUserInfilled() ? (
                <Navigate to={"/home"} />
              ) : (
                <Navigate to={"/register"} />
              )
            ) : (
              <SignIn />
            )
          }
        />
        <Route
          path="/register"
          element={hasUser || isLoading ? <Register /> : <Navigate to={"/"} />}
        />
        <Route
          path="/home"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <Home />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route
          path="/marketplace"
          element={
            hasUser || isLoading ? <Marketplace /> : <Navigate to={"/"} />
          }
        />
        <Route
          path="/profile"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <Profile />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route
          path="/settings/transactions"
          element={
            hasUser || isLoading ? <Transactions /> : <Navigate to={"/"} />
          }
        />
        <Route
          path="/transaction/:id"
          element={
            hasUser || isLoading ? <TransactionDetail /> : <Navigate to={"/"} />
          }
        />
        <Route
          path="/game"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <Game />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route
          path="/game-details"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <GameDetails />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route
          path="/review"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <Review />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route path="/game-details/:id" element={<PublicGame />} />
        <Route
          path="/game-edit/:id"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <GameEdit />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route
          path="/settings"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <Settings />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
        <Route
          path="/settings/account"
          element={
            isUserInfilled() && (hasUser || isLoading) ? (
              <Account />
            ) : (
              <Navigate to={"/"} />
            )
          }
        />
      </Routes>
    </Router>
  );
};
const mapDispatchToProps = {};

const connector = connect(undefined, mapDispatchToProps);
const AppRouterRedux = connector(AppRouter);

export { AppRouterRedux as AppRouter };
